import { t } from "../../../services/utils";
import React from "react";
import {
  primaryDark60,
  primaryDark,
  red700,
  primary,
  primaryDark10,
  grey50,
} from "../../../constants/colors";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Inputbase from "@material-ui/core/InputBase";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import { calculateTextHeight } from "../../../services/utils";
import Tooltip from "../../../components/Tooltip";
import "./Toolbar.css";
import { Button } from "@material-ui/core";
import IconMoon from "../../../components/IconMoon";
class Toolbar extends React.Component {
  constructor(props) {
    super(props);
  }
  onLikeToggleClicked = (e) => {
    if (this.props.likedByMe) {
      this.props.handler.unlikeStory(this.props.storyId);
    } else {
      this.props.handler.likeStory(this.props.storyId);
    }
  };
  onShare = () => {
    // this.props.handler.onShare(this.props.storyId);
  };
  render = () => {
    let styles = {
      container: {
        display: "flex",
        flexDirection: "row",
        flex: "1 1 auto",
        backgroundColor: "white",
        alignItems: "center",
        paddingLeft: 16,
        paddingTop: 20,
        paddingBottom: 20,
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      likeButton: {
        padding: 10,
        margin: -10,
        marginRight: 0,
      },
      shareButton: {
        padding: 10,
        marginLeft: 20,
      },
      textFieldWrapper: {
        paddingLeft: 10,
        paddingRight: 10,
        marginTop: 6,
        flex: "1 1 auto",
      },
      commentIcon: {
        width: 16,
        height: 16,
        marginRight: 10,
      },
      comments: {
        display: "flex",
        marginLeft: 33,
        alignItems: "center",
      },
      num: {
        fontSize: 14,
        fontWeight: "500",
        color: primaryDark,
      },
      likes: {
        cursor: "pointer",
      },
      btn: {
        display: "flex",
      },
    };
    const { likes, comments, me } = this.props;
    return (
      <div style={styles.container}>
        <div style={styles.likeBtn}>
          <Button
            variant="outlined"
            onClick={this.onLikeToggleClicked}
            startIcon={
              <IconMoon color={this.props.likedByMe && red700} icon="like" />
            }
            data-testid="story-like-button"
            style={{
              textTransform: "none",
              marginRight: 16,
            }}
          >
            {t("like")}
          </Button>
          {/* <IconButton
           style={styles.likeButton}
           onClick={this.onLikeToggleClicked}
           >
           {!this.props.likedByMe && (
            <Icon
              style={{ color: primaryDark60, fontSize: 21 }}
              className={"material-icons"}
            >
              favorite_border
            </Icon>
           )}
           {this.props.likedByMe && (
            <Icon
              style={{ color: red700, fontSize: 21 }}
              className={"material-icons"}
            >
              favorite
            </Icon>
           )}
           </IconButton>
           Like */}
        </div>
        {likes.length > 0 && (
          <Tooltip
            showOnClick
            ref="tooltip"
            customPadding
            title={likes.map((like, index) => {
              return (
                <div
                  key={like.user_id}
                  style={{
                    fontSize: 13,
                    color: "white",
                    marginTop: index !== 0 && 8,
                  }}
                >
                  {like.user_id !== me.id ? like.first_name : t("you")}
                </div>
              );
            })}
          >
            <div
              style={{
                ...styles.num,
                ...styles.likes,
              }}
              className="hover"
            >
              {likes.length} {likes.length > 1 ? t("likes") : t("like")}
            </div>
            {/* Tooltip renders likes list on hover - "You" for current user */}
          </Tooltip>
        )}
        {/* {likes.length === 0 && <div>Like</div>} */}
        {/* <IconButton style={styles.shareButton} onClick={this.onShare}>
          <Icon
            style={{ color: primaryDark60, fontSize: 21 }}
            className={"material-icons"}
          >
            share
          </Icon>
         </IconButton>
         <div>Share</div> */}
        {/* {comments.length > 0 && (
          <div style={styles.comments}>
            <img style={styles.commentIcon} src={ require( "../../../img/comment.png") } />
            <div style={styles.num}>
              {comments.length} {comments.length > 1 ? "Comments" : "Comment"}
            </div>
          </div>
         )} */}
      </div>
    );
  };
  static getHeight(props) {
    return 80;
  }
}
export default Toolbar;
